var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-allow"},[_vm._t("default",function(){return [_vm._m(0)]})],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('img',{attrs:{"src":require("../../assets/images/not-allow.png")}}),_c('h2',[_vm._v("无权访问")]),_c('p',[_vm._v("如您需要访问该页面，请联系系统管理员")])])
}]

export { render, staticRenderFns }